import moment from 'moment-timezone';
import { Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';

function BookingWindowWarning({ island, start_time, min_booking_window, isAgent }) {
    const timezone = island?.timezone || 'Pacific/Honolulu';
    // allow agents to book all Vendors into the past even if they are not the client, we show warning in this case
    const hawaiiNow = moment()
        .tz(timezone)
        .format('YYYY-MM-DD HH:mm:ss');

    // TODO: timezones are fine?
    // booking window closes / regular bookings are accepted before:
    const bookingWindowCloses = moment.utc(start_time).subtract(min_booking_window, 'hours');

    // bookingWindowCloses is within next 24 hour - show warning (isAgent, we might want to show this to guests as well)
    const bookingWindowClosesWithin24HoursWarning =
        isAgent &&
        bookingWindowCloses.isBetween(
            moment(hawaiiNow).format('YYYY-MM-DD HH:mm'),
            moment(hawaiiNow)
                .add(24, 'hours')
                .format('YYYY-MM-DD HH:mm')
        );
    // agents are currently unable to determine that cut-off time has expired, so we show a warning that booking cut-off window is expired when bookingWindowCloses is before next 24 hour and bookingWindowClosesWithin24HoursWarning not displayed
    const bookingCutOffExpiredWarning =
        isAgent &&
        bookingWindowCloses.isBefore(
            moment(hawaiiNow)
                .add(24, 'hours')
                .format('YYYY-MM-DD HH:mm')
        ) &&
        !bookingWindowClosesWithin24HoursWarning;

    if (bookingWindowClosesWithin24HoursWarning) {
        return (
            <Grid item>
                <Alert severity="warning">
                    <b>Activity local time: {moment(hawaiiNow).format('MMMM Do YYYY, h:mm a')}</b>
                    <br />
                    Regular bookings are accepted before{' '}
                    {bookingWindowCloses.format('MMMM Do YYYY, h:mm a')}.
                </Alert>
            </Grid>
        );
    }
    if (bookingCutOffExpiredWarning) {
        return (
            <Grid item>
                <Alert severity="warning">
                    <b>Activity local time: {moment(hawaiiNow).format('MMMM Do YYYY, h:mm a')}</b>
                    <br />
                    Booking cut-off window has expired:{' '}
                    {bookingWindowCloses.format('MMMM Do YYYY, h:mm a')}.
                </Alert>
            </Grid>
        );
    }

    return null;
}

export default BookingWindowWarning;
